// store/useAuthModalsStore.js
import { create } from "zustand";

const useAuthModalsStore = create((set) => ({
  loginOpen: false,
  forgotPasswordOpen: false,
  newPasswordOpen: false,
  newRecoveryPasswordOpen: false,
  signInOpen: false,
  signInOtpOpen: false,
  signInDetailsOpen: false,
  demoOpen: false,

  // actions
  setLoginOpen: (val) => set({ loginOpen: val }),
  setForgotPasswordOpen: (val) => set({ forgotPasswordOpen: val }),
  setNewPasswordOpen: (val) => set({ newPasswordOpen: val }),
  setNewRecoveryPasswordOpen: (val) => set({ newRecoveryPasswordOpen: val }),
  setSignInOpen: (val) => set({ signInOpen: val }),
  setSignInOtpOpen: (val) => set({ signInOtpOpen: val }),
  setSignInDetailsOpen: (val) => set({ signInDetailsOpen: val }),
  setDemoOpen: (val) => set({ demoOpen: val }),
}));

export default useAuthModalsStore;
